<!--
 * @Description: 消息管理消息列表
 * @Author: xu wei
 * @Date: 2020-02-26 15:04:25
 * @LastEditTime: 2020-06-03 14:21:39
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>消息管理</el-breadcrumb-item>
        <el-breadcrumb-item>消息列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="gs_tablebox">
      <div style=" margin-top: 20px;background: #fff;padding: 5px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-button size="small" type="primary" @click="dialog.show=true">增加</el-button>
        <el-button size="small" type="success" :disabled="selectList.length===0" @click="sortNews">排序</el-button>
      </div>
      <el-table ref="moduleTable" size="mini" @selection-change="selchange" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="date" label="排序" width="80">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.sort" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column prop="date" label="发布日期">
        </el-table-column>
        <el-table-column prop="publisher" label="发布人">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.state" @change="switchchange(scope.row)" active-color="#4a90e2" inactive-color="#e4eaec"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width='150'>
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="editnotice(scope.row)">编辑</el-button>
            <!-- <el-button size="mini" type="primary">禁用</el-button> -->
            <el-button size="mini" type="danger" @click="handleClose(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog title="编辑公告" :visible.sync="dialog1.show" @close="dialoginit" custom-class="gs_dialog" width="500px">
      <div class="dialoglist">
        <ul>
          <li class="clearfix">
            <span class='tit'>公告标题</span>
            <span class="txtbox">
              <el-input v-model="dialog1.title"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>公告内容</span>
            <span class="txtbox">
              <el-input type="textarea" v-model="dialog1.content"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>发布人</span>
            <span class="txtbox">
              <el-input v-model="dialog1.issuer"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <div class="button_center">
        <el-button size="small" type="primary" @click="editapply">提交</el-button>
      </div>
    </el-dialog>
    <!-- 增加弹框 -->
    <el-dialog title="增加公告" :visible.sync="dialog.show" @close="addinit" custom-class="gs_dialog" width="500px">
      <div class="dialoglist">
        <ul>
          <li class="clearfix">
            <span class='tit'>公告标题</span>
            <span class="txtbox">
              <el-input v-model="dialog.title"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>公告内容</span>
            <span class="txtbox">
              <el-input type="textarea" v-model="dialog.content"></el-input>
            </span>
          </li>
          <li class="clearfix">
            <span class='tit'>发布人</span>
            <span class="txtbox">
              <el-input v-model="dialog.issuer"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <div class="button_center">
        <el-button size="small" type="primary" @click="addnotice">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: {
        show: false,
        title: '',
        content: '',
        issuer: ''
      },
      dialog1: {
        show: false,
        title: '',
        content: '',
        issuer: '',
        id: '',
        state: true
      },
      titleannouncement: '', // 公告标题
      substance: '', // 公告内容
      issuer: '', // 发布人
      selectList: [], // 多选的列表
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      options: [],
      tableData: [],
      editorialBulletin: false
    };
  },
  methods: {
    // 获取列表
    getlist() {
      this.$api.news
        .newlist({
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 多选发生变化
    selchange(data) {
      this.selectList = data.map((item) => {
        return { id: item.id };
      });
    },
    // 排序列表
    sortNews() {
      let flag = true;
      let arr1 = this.selectList.map((item) => {
        let sel = this.tableData.filter((li) => {
          return li.id === item.id;
        })[0];
        if (sel.sort === '') {
          flag = false;
        } else {
          return {
            id: item.id,
            sort: parseInt(sel.sort)
          };
        }
      });
      if (flag) {
        this.$api.news
          .sortNews(arr1)
          .then((data) => {
            if (data.status === 200) {
              this.$messageSuccess('排序成功！');
              this.getlist();
            }
          })
          .catch((err) => {
            this.$messageError(err.message);
          });
      } else {
        this.$messageError('排序不能为空！');
      }
    },
    // 添加公告
    async addnotice() {
      this.$api.news
        .addnews({
          content: this.dialog.content,
          publisher: this.dialog.issuer,
          title: this.dialog.title,
          state: true
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功');
            this.dialog.show = false;
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑公告
    editnotice(data) {
      this.dialog1.title = data.title;
      this.dialog1.content = data.content;
      this.dialog1.issuer = data.publisher;
      this.dialog1.id = data.id;
      this.dialog1.state = data.state;
      this.dialog1.show = true;
    },
    async editapply() {
      this.$api.news
        .editnews({
          id: this.dialog1.id,
          content: this.dialog1.content,
          publisher: this.dialog1.issuer,
          title: this.dialog1.title,
          state: this.dialog1.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功');
            this.dialog1.show = false;
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    addinit() {
      this.dialog.title = '';
      this.dialog.content = '';
      this.dialog.issuer = '';
    },
    dialoginit() {
      this.dialog1.title = '';
      this.dialog1.content = '';
      this.dialog1.issuer = '';
      this.dialog1.id = '';
      this.dialog1.state = '';
      this.dialog1.show = false;
    },
    // 改变状态
    async switchchange(data) {
      this.$api.news
        .editnews({
          id: data.id,
          content: data.content,
          publisher: data.publisher,
          title: data.title,
          state: data.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('状态修改成功');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除公告
    async deletenew(data) {
      this.$api.news
        .deletenews({
          id: data.id,
          content: data.content,
          publisher: data.publisher,
          title: data.title,
          state: data.state
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功!');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除公告
    async handleClose(data) {
      this.$confirm('是否确定删除公告信息')
        .then(() => {
          this.deletenew(data);
        })
        .catch(() => {});
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.button_center {
  text-align: center;
  padding-bottom: 10px;
}
.dialoglist {
  ul {
    padding-left: 30px;
    li {
      margin-bottom: 10px;
      .tit {
        float: left;
        width: 100px;
        height: 30px;
        line-height: 30px;
      }
      .txtbox {
        float: left;
        width: 250px;
      }
    }
  }
}
</style>
